import { ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { faFlag, faEnvelope, faPhone, faCaretUp, faExternalLinkAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import {
    faXTwitter,
    faFacebookSquare,
    faYoutube,
    faInstagram,
    faLinkedin,
    faTiktok,
    faWhatsapp,
    faFlickr,
} from '@fortawesome/free-brands-svg-icons';

import { NavigationService } from './../navigation.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TemplateRef } from '@angular/core';
import { SetupService } from '@core/services/setup';
import { WINDOW } from 'src/app/core/http/window.providers';
import { LocalStorage } from '@core/localstorage';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    menu: any;
    certifications: any[] = [];

    icons = {
        /* contact */
        flag: faFlag,
        phone: faPhone,
        email: faEnvelope,
        clock: faClock,
        /* social */
        facebook: faFacebookSquare,
        twitter: faXTwitter,
        youtube: faYoutube,
        whatsapp: faWhatsapp,
        instagram: faInstagram,
        linkedin: faLinkedin,
        tiktok: faTiktok,
        flickr: faFlickr,

        /* other */
        caretUp: faCaretUp,
        link: faExternalLinkAlt,
    };

    @Input('type') type: string;
    @ViewChild('footerDefault') template01: TemplateRef<any>;
    @ViewChild('footerCentered') template02: TemplateRef<any>;
    @ViewChild('footerTwoColumns') template03: TemplateRef<any>;
    @ViewChild('footerThreeColumns') template04: TemplateRef<any>;

    footerTemplate: TemplateRef<any>;
    constructor(
        private navigationService: NavigationService,
        private cdRef: ChangeDetectorRef,
        public setupService: SetupService,
        @Inject(WINDOW) public window: Window,
        private localStorage: LocalStorage
    ) {}

    ngOnInit(): void {
        this.getSocial();
        this.getMenu();
        this.getPartnersCertification();
    }

    ngAfterViewInit() {
        this.defineTemplate();
        this.cdRef.detectChanges();
        this.setupService.setFooterImage();
    }

    defineTemplate() {
        switch (this.type) {
            case '1':
                this.footerTemplate = this.template01;
                break;
            case '2':
                this.footerTemplate = this.template02;
                break;
            case '3':
                this.footerTemplate = this.template03;
                break;
            case '4':
                this.footerTemplate = this.template04;
                break;
            default:
                this.footerTemplate = this.template01;
                break;
        }
    }

    /**
     * getMenu() - Buscar itens de menu
     */
    getMenu() {
        this.navigationService
            .getMenuFooter()
            .pipe(map((response) => response.registers))
            .subscribe((response) => {
                this.menu = response;
            });
    }

    /**
     * getPartnersCertification() - Listar selos e certificações
     */
    getPartnersCertification() {
        return this.navigationService.getPartnersCertifications().subscribe((response) => {
            this.certifications = response.registers;
        });
    }
    /**
     * certificationsPerGroup() - Retorna a quantidade de certificações por grupo
     */
    get certificationsPerGroup(): number {
        return window.innerWidth < 992 ? 1 : window.innerWidth >= 992 && window.innerWidth < 1240 ? 3 : 6;
    }

    /**
     * certificationsGroups() - Retorna a quantidade de grupos de certificações
     */
    get certificationsGroups(): number[] {
        return Array(Math.max(Math.ceil((this.certifications?.length || 0) / this.certificationsPerGroup), 0))
            .fill(0)
            .map((_, i) => i);
    }
    /**
     * getSocial() - Buscar itens das redes sociais
     */
    getSocial() {
        this.navigationService.getSocialMenu().subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    getImageHeight(i) {
        const isDesktop = window.innerWidth >= 1240;
        const isXSmall = window.innerWidth < 530;
        if (typeof i !== 'number') return isDesktop ? '100px' : '80px';

        if (i === 0) return isDesktop ? '80px' : '70px';

        return isDesktop ? '80px' : '80px';
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }

    /**
     * backToTop - Scroll para o topo da página
     * @return void;
     */
    backToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    isCbt() {
        return (
            this.localStorage.getHost().includes('cbt.tenisintegrado.com.br') ||
            this.localStorage.getHost().includes('cbt.esp.br') ||
            this.localStorage.getHost().includes('cbt-tenis.com.br') ||
            this.localStorage.getHost().includes('cbtenis.com.br')
        );
    }

    getRegisterImage() {
        if (this.localStorage.isPickleball()) {
            return '/assets/images/cadastro_footer_pickleball.jpg';
        }

        return this.isCbt() ? '/assets/images/cadastro_footer_cbt.png' : '/assets/images/cadastro_footer.png';
    }

    clearPhoneNumber(phone: string): string {
        return phone.replace(/[^\d]/g, '');
    }

    hasOfficeHours(): boolean {
        const officeHours = this.setupService?.contact?.officeHours;
        if (Array.isArray(officeHours) && officeHours.length == 0) return false;

        if (typeof officeHours === 'object' && Object.keys(officeHours).length == 0) return false;

        return !!officeHours;
    }

    orderDays(a, b) {
        return a;
    }
}
